import {
    getDataStructure
} from '~/shared/src/utilities/modules/finder';
import {
    getColumnDefinitions
} from '~/shared/src/utilities/modules/finderOverview';

import {store} from '~/frontend/src/store';
import {
    defaultProps as finderOverviewDefaultProps,
    ComponentProps as FinderOverviewComponentProps
} from '~/frontend/src/modules/panels/Finder/overview';


export default {
    hydrate( inboundState : FinderOverviewComponentProps ) : FinderOverviewComponentProps {
        return inboundState;
    },

    rehydrate( outboundState : FinderOverviewComponentProps ) : FinderOverviewComponentProps {
        const retVal       = {
                  ...outboundState
              },
              schema       = outboundState.schema ?? finderOverviewDefaultProps.schema,
              status       = outboundState.status ?? finderOverviewDefaultProps.status,
              timestamp    = outboundState.timestamp ?? finderOverviewDefaultProps.timestamp,
              itemTypeName = outboundState.itemTypeName ?? finderOverviewDefaultProps.itemTypeName,
              user         = store.getState()?.session?.user;

        if ( user ) {
            retVal.dataStructure = getDataStructure( schema, itemTypeName, user );
            if ( retVal.dataStructure ) {
                retVal.columnDefinitions = getColumnDefinitions( retVal.dataStructure, schema, status, timestamp, itemTypeName, user );
            }
        }

        return retVal;
    }
};
